/*
 * @Author: Fu Xueqian 
 * @Date: 2020-08-12 14:01:49 
 * @Last Modified by: Fu Xueqian
 * @Last Modified time: 2020-09-02 15:47:48
 * 路由器设置，网页路径
 */

import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Index from '@/components/Index'
import ResetPassword from '@/components/ResetPassword'
import SetNewPassword from '@/components/SetNewPassword'
import Search from '@/components/Search'
import My from '@/components/My'
import History from '@/components/iframe/History'
import Searching from '@/components/iframe/Searching'
import Report from '@/components/iframe/Report'
import CheckResult from '@/components/iframe/CheckResult'
import Authentication from '@/components/iframe/Authentication'
import Message from '@/components/iframe/Message'
import Appointment from '@/components/iframe/Appointment'
import AppointmentProcess from '@/components/iframe/AppointmentProcess'
import Feedback from '@/components/iframe/Feedback'
import Information from '@/components/iframe/Information'
import ResultView from '@/components/iframe/ResultView'
import Store from '@/components/store'
import Pay from '@/components/pay'
import OrderList from '@/components/iframe/OrderList'
import OrderDetails from '@/components/iframe/OrderDetails'
Vue.use(Router)


export default new Router({
  mode: 'history',//使用history模式去掉URL后面的#
  routes: [
    {
      path:'/login',
      component:Login
    },{
      path:'/register',
      component:Register
    },{
      path:'/',
      component:Index,
    },{
      path:'/resetpassword',
      component:ResetPassword
    },{
      path:'/setnewpassword',
      component:SetNewPassword
    },{
      path:'/search',
      component:Search,
      meta:{
        auth:true
      }
    },{
      path:'/my',
      component:My,
      meta:{
        auth:true
      }
    },{
      path:'/history',
      component:History
    },{
      path:'/searching',
      component:Searching
    },{
      path:'/report',
      component:Report
    },{
      path:'/check',
      component:CheckResult
    },{
      path:'/auth',
      component:Authentication
    },{
      path:'/message',
      component:Message
    },{
      path:'/appointment',
      component:Appointment
    },{
      path:'/appointmentprocess',
      component:AppointmentProcess
    },{
      path:'/feedback',
      component:Feedback
    },{
      path:'/info',
      component:Information
    },{
      path:'/resultview',
      component:ResultView,
      meta:{
        auth:true
      }
    },
    {
      path:'/store',
      component:Store,
      meta:{
        auth:true
      }
    },
    {
      path:'/pay',
      component:Pay,
      meta:{
        auth:true
      }
    },{
      path:'/OrderList',
      component:OrderList,
      meta:{
        auth:true
      }
    },{
      path:'/orderDetails',
      component:OrderDetails,
    }
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js